<template>
  <div
    class="task-priority-display"
    :class="rootClasses"
    :data-testid="dataTestId"
  >
    <template v-if="variant === 'toggle-segment'">
      <v-btn
        v-for="option in priorityOptions"
        :key="option.label"
        depressed
        small
        class="task-priority-display__segment"
        :class="[
          `task-priority-display__segment--${option.cssModifier}`,
          { 'task-priority-display__segment--selected': isSelected(option.label) },
        ]"
        :data-testid="`task-priority-display__segment--${option.cssModifier}`"
        @click="onSegmentSelect(option.label)"
      >
        <v-icon small class="task-priority-display__icon">{{ getSegmentIcon(option) }}</v-icon>
        <span class="task-priority-display__label">{{ option.label }}</span>
      </v-btn>
    </template>

    <template v-else-if="hasPriority">
      <v-icon
        small
        class="task-priority-display__icon"
        :class="`task-priority-display__icon--${display.cssModifier}`"
      >
        {{ display.toggleIcon || display.icon }}
      </v-icon>
      <span class="task-priority-display__label">{{ display.label }}</span>
    </template>
    <span v-else class="task-priority-display__label task-priority-display__label--empty">—</span>
  </div>
</template>

<script>
import './TaskPriorityDisplay.scss';
import { PRIORITY_VALUES } from '../../../../../utils/listConstants';
import { getPriorityDisplay } from '../../../../../utils/tasklistHelpers';

/** Icon + label priority treatment shared by list table and Add Task (5780 / 5782). */
export default {
  name: 'TaskPriorityDisplay',

  props: {
    priority: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'cell',
      validator: (value) => ['cell', 'toggle-segment'].includes(value),
    },
    value: {
      type: String,
      default: '',
    },
    dataTestId: {
      type: String,
      default: 'task-priority-display',
    },
  },

  computed: {
    hasPriority() {
      return Boolean(this.priority && String(this.priority).trim());
    },

    display() {
      return getPriorityDisplay(this.priority);
    },

    priorityOptions() {
      return PRIORITY_VALUES.map((label) => getPriorityDisplay(label));
    },

    rootClasses() {
      const classes = [`task-priority-display--${this.variant}`];
      if (this.variant === 'cell' && this.display.cssModifier) {
        classes.push(`task-priority-display--${this.display.cssModifier}`);
      }
      return classes;
    },
  },

  methods: {
    getSegmentIcon(option) {
      return option.toggleIcon || option.icon;
    },

    isSelected(label) {
      return (this.value || this.priority) === label;
    },

    onSegmentSelect(label) {
      this.$emit('input', label);
      this.$emit('change', label);
    },
  },
};
</script>
